export const formatCurrency = (value: string | number) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(Number(value));
};

export const formatDate = (dateStr: string) => {
  if (!dateStr || dateStr === '1899-12-30') return '-';
  
  // Corrigindo o problema de fuso horário
  // Formato esperado: YYYY-MM-DD (ISO)
  if (dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
    // Dividir a data em partes
    const [year, month, day] = dateStr.split('-').map(Number);
    // Formatar diretamente sem criar objeto Date para evitar problemas de timezone
    return `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`;
  }
  
  // Fallback para o método anterior caso o formato seja diferente
  const date = new Date(dateStr);
  return date.toLocaleDateString('pt-BR');
};
